import React from 'react'

type AirConditionerProps = {
  className?: string
}

const _AirConditioner = (props: AirConditionerProps) => (
  <svg
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.06912 12L5.29868 14.1768L0.517637 12.8958L0 14.8276L2.84919 15.591L0.176897 17.1339L1.1769 18.8659L3.84921 17.3231L3.08576 20.1723L5.01761 20.69L6.2987 15.9089L10.0692 13.732V18.0858L6.56917 21.5858L7.98339 23.0001L10.0692 20.9143V24H12.0692V20.9143L14.1549 23.0001L15.5691 21.5858L12.0692 18.0859V13.7321L15.8396 15.9089L17.1207 20.69L19.0525 20.1723L18.2891 17.3231L20.9615 18.866L21.9615 17.134L19.2891 15.5911L22.1383 14.8276L21.6207 12.8958L16.8396 14.1769L13.0691 12L16.8396 9.82308L21.6207 11.1042L22.1383 9.17232L19.2891 8.40887L21.9615 6.86594L20.9615 5.13389L18.2891 6.6768L19.0525 3.82761L17.1207 3.30998L15.8396 8.09102L12.0692 10.2679V5.91425L15.5691 2.41428L14.1549 1.00007L12.0692 3.08582V0H10.0692V3.08585L7.98339 1.00006L6.56917 2.41427L10.0692 5.91427V10.268L6.2987 8.09107L5.01761 3.30998L3.08576 3.82762L3.84921 6.67686L1.1769 5.13399L0.176897 6.86604L2.84919 8.40889L0 9.17233L0.517637 11.1042L5.29868 9.82311L9.06912 12Z"
      fill="currentColor"
    />
  </svg>
)

export default React.memo(_AirConditioner)
